import apiClient from "../http/apiClient";
import { HOME_ENDPOINTS } from "../http/endpoints";

export async function getHomeDashboard(params = {}) {
  const response = await apiClient.get(HOME_ENDPOINTS.dashboard, { params });
  return response.data;
}

export const homeService = {
  getHomeDashboard,
};

export default homeService;
